import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Hyperlink from '@sport1/react-elements/Hyperlink'
import ListTeaserHeadlineFont from '../../Theme/Fonts/ListTeaserHeadline'
import TeaserInfo from '../../TeaserInfo'
import { BasicTeaserType, TaboolaRegionItem, TeaserProps } from '../TeaserInterface'
import { BackgroundColorTypes } from '../../Theme/Fonts/FontTypes'
import LinkProps from '../../Link/LinkProps'
import VideoLabelProps from '../../BaseComponents/Labels/Video/VideoLabelProps'
import ListTeaserImage from './Image'

export type ListTeaserProps = BasicTeaserType &
    Omit<TeaserProps, 'backgroundColor'> &
    TaboolaRegionItem &
    LinkProps &
    VideoLabelProps & {
        /** background color of the teaser */
        backgroundColor?: BackgroundColorTypes
        /** url for the hyperlink function */
        href?: string
        className?: string
    }

const ListTeaser: FunctionComponent<ListTeaserProps> = ({
    tag,
    headlineText,
    href = '',
    backgroundColor = 'pearl',
    textColor = 'onyx-5',
    onShare,
    onPress,
    published,
    mainImageUrl,
    mainImageAlt,
    type,
    testID,
    webTBRegionItem,
    innerRef,
    webRel,
    teaserIcon,
}): ReactElement | null => {
    return (
        <Grid ref={innerRef} horizontal noExpand backgroundColor={backgroundColor}>
            <Hyperlink
                href={href}
                onPress={onPress}
                webRel={webRel}
                testID={testID}
                webTBRegionItem={webTBRegionItem}
            >
                <ListTeaserImage
                    imageUrl={mainImageUrl}
                    alt={mainImageAlt}
                    type={type}
                    teaserIcon={teaserIcon}
                />
            </Hyperlink>
            <Grid marginLeft={5} minWidth={0}>
                <Grid>
                    <Hyperlink
                        href={href}
                        onPress={onPress}
                        webRel={webRel}
                        webTBRegionItem={webTBRegionItem}
                    >
                        <ListTeaserHeadlineFont
                            color={textColor}
                            numberOfLines={3}
                            className={webTBRegionItem === '' ? 's1-taboola-title' : undefined}
                        >
                            {headlineText}
                        </ListTeaserHeadlineFont>
                    </Hyperlink>
                </Grid>
                <Grid noExpand>
                    <TeaserInfo
                        published={published}
                        name={tag?.name}
                        imageUrl={tag?.imageUrl}
                        alt={tag?.imageAlt}
                        onShare={onShare}
                        tintColor={tag?.imageTintColor}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ListTeaser
